module.exports = __webpack_public_path__ + "static/prototype@2x-7fbb935192d17a33a7b8efa4ceef6fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/prototype@2x.jpg
// module id = 2616
// module chunks = 168707334958949